export function getHostname() {
  if (typeof window === 'undefined') return '';
  return window.location.hostname || '';
}

const DEFAULT_REMOTE_AUTH_SERVER = 'https://auth-server-61ms.onrender.com';
const DEFAULT_REMOTE_API_BASE = 'https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod';

function readEnv(name) {
  const value = process.env[name];
  if (typeof value !== 'string') return '';
  return value.trim().replace(/^['"]|['"]$/g, '');
}

export function isLocalHost(hostname = getHostname()) {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
}

export function getAuthServerBase() {
  const configured = readEnv('REACT_APP_AUTH_SERVER');

  if (configured) {
    return configured;
  }

  return DEFAULT_REMOTE_AUTH_SERVER;
}

export function getApiBase() {
  if (isLocalHost() && readEnv('REACT_APP_FORCE_REMOTE_API') !== 'true') {
    return '';
  }

  return (
    readEnv('REACT_APP_API_BASE') ||
    readEnv('REACT_APP_API_BASE_URL') ||
    (isLocalHost() ? 'http://localhost:4001' : null) ||
    DEFAULT_REMOTE_API_BASE
  );
}
